<div class="group-invite-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true" [disableNavigateBack]="true"
    (onNavigateBackClick)="navigateBack()"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="invitation-content_header">
      <div class="group-icon">
        <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-single"></div>
      </div>
      <div class="content-container">
        <h2 class="title" langkey="phInHouse_UseName_Request_Title"></h2>
        <span class="text content-container--subfont" langkey="phInHouse_UseName_Request_Desc"></span>
      </div>
    </div>
    <div class="name-inupt-form">
      <div class="ya-input-container">
        <div class="ya-input-wrapper">
          <div class="inputs-text">
            <input a11y_Input type="text" class="ya-input-text" (blur)="setWebView()" [placeholder]="inputPlaceholder"
              [formControl]="usernameInputControl">
          </div>
          <ng-container *ngIf="usernameInputControl.touched && usernameInputControl.invalid">
            <ng-container *ngIf="usernameInputControl.errors && activeError(usernameInputControl, field.UserName)">
              <ya-errorvalidation [controlValidation]="true" [errorMessage]="activeError(usernameInputControl, field.UserName)"></ya-errorvalidation>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="ya-button-group-wrapper">
      <div class="ya-button-group-container">
        <div class="ya-webshop-button-container">
          <ng-container
            *ngIf="(usernameInputControl.touched && usernameInputControl.valid||isLogin); then activeButton else deactiveButton">
          </ng-container>
          <div
            [class]="usernameInputControl.invalid && usernameInputControl.touched ? 'ya-button-group-wrapper errorMargin' : 'ya-button-group-wrapper noErrorMargin'">
            <ng-template #activeButton>
              <button a11y_Button mat-flat-button (click)="NavigateToLandingPage()">
                <span langkey="phGlobal_Continue"></span>
              </button>
            </ng-template>
            <ng-template #deactiveButton>
              <button a11y_Button mat-flat-button disabled>
                <span langkey="phGlobal_Continue"></span>
              </button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>